import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import StudentFeeForm from "./StudentFeeForm";
import { useNavigate } from "react-router-dom";
import OnlineFeesBanner from "../../assets/OnlineFees.png";
import PageTitle from "../../Components/PageTitle";

const OnlineFees = () => {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <PageTitle
        title="Online Fees Payment - Shree Mangalam School"
        description="Pay your school or coaching fees securely online at Shree Mangalam School. Simple, safe, and fast fee payment for all programs including RIMC and Sainik School coaching."
        url="/online-fees"
        keywords="online fees payment, pay school fees, Shree Manglam fees, RIMC coaching fees, sainik school fee payment, secure fee portal"
      />

      <Header image={OnlineFeesBanner} alt={"Shree Mangalam School"} />

      <Container sx={{ my: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Online Fees Payment
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          You can now conveniently pay school fees online using any UPI app.
          Please scan the QR code below and enter the correct amount. Don't
          forget to mention your child’s name and class in the payment note.
        </Typography>

        {/* <StudentFeeForm /> */}
        <StudentFeeForm
          onSuccess={(data) =>
            navigate("/qr-page", { state: { feeData: data } })
          }
        />
      </Container>

      <CallToEnroll />
      <Footer />
    </>
  );
};

export default OnlineFees;
